const HisClipboardCheck = ({ color, sx }) => {
  const strokeColor = color ?? "#708FBB";
  const _sx = sx ?? {};

  return (
    <svg
      style={_sx}
      width="35"
      height="35"
      viewBox="0 0 35 35"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.3988 3.22066H13.6488C12.8434 3.22066 12.1905 3.87358 12.1905 4.67899V7.59566C12.1905 8.40107 12.8434 9.05399 13.6488 9.05399H22.3988C23.2042 9.05399 23.8572 8.40107 23.8572 7.59566V4.67899C23.8572 3.87358 23.2042 3.22066 22.3988 3.22066Z"
        stroke={strokeColor}
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.8574 6.1372H26.7741C27.5476 6.1372 28.2895 6.44449 28.8365 6.99147C29.3835 7.53845 29.6908 8.28031 29.6908 9.05386V29.4705C29.6908 30.2441 29.3835 30.9859 28.8365 31.5329C28.2895 32.0799 27.5476 32.3872 26.7741 32.3872H9.27409C8.50054 32.3872 7.75867 32.0799 7.21169 31.5329C6.66471 30.9859 6.35742 30.2441 6.35742 29.4705V9.05386C6.35742 8.28031 6.66471 7.53845 7.21169 6.99147C7.75867 6.44449 8.50054 6.1372 9.27409 6.1372H12.1908"
        stroke={strokeColor}
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.6493 20.7208L16.566 23.6375L22.3993 17.8041"
        stroke={strokeColor}
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default HisClipboardCheck;
